const LoggedInLayout = () => import("../../views/LoggedInLayout.vue");
const User = r => require.ensure([], () => r(require('./views/User.vue')))
const Usercblmapping = r => require.ensure([], () => r(require('./views/Usercblmapping.vue')))

const moduleRoute = {
  path: "/",
  component: LoggedInLayout,
  children: [
    {
      path: "/user",
      component: User
    },
    {
      path: "/user/cblmapping",
      component: Usercblmapping
    }
  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
